import { PayLinkStepOption, PayLinkStepOptionPayload } from "@fitness-force/models";

export const SIGNUP_STEPS_STATE: PayLinkStepOptionPayload = {
    steps: [] as PayLinkStepOption[],
} as PayLinkStepOptionPayload;